/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// we need simple_paste plugin instead of out-of-the-box paste plugin,
// because default plugin is not compatible with WSC proofreader (look into GJG-10604)

(function() {
  tinymce.PluginManager.add('simple_paste', function (editor) {
    editor.on('init', function () {
      editor.getBody().addEventListener('paste', function (event) {
        var text = event.clipboardData.getData('text/plain');

        event.stopPropagation();
        event.preventDefault();

        editor.insertContent(text);
      }, true);
    });
  });
})();
